import {Button, Col, InputGroup, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import {Formik} from "formik";
import Form from "react-bootstrap/Form";
import React from "react";
import tableDataModules from "../../controller/tableDataModules";
import {useNavigate} from "react-router-dom";


function EditForm(props) {
    const nav = useNavigate();
    function regenerate() {
        let distance = parseInt(prompt("Please enter the distance in mm", "15"));
        if (distance != null) {
            tableDataModules.regenerateCase(props.caseID, distance).then(res => {
                alert(res.data)
            })
        }else{
            regenerate();
        }
    }

    function reprocess(){
        if(window.confirm("Are you sure you want to reprocess all submissions?")){
            tableDataModules.reprocessCase(props.caseID).then(res=>{
                alert("Done")
            })
        }
    }

    function deleteCase(){

        if(window.confirm("Are you sure you want to delete the case")){
            tableDataModules.deleteCase(props.caseID).then(res=>{
                nav('/')
            })
        }
    }

    function newSession(){
        tableDataModules.createSession(props.caseID).then(res=>{
            alert("Session created (id "+res.data.id+")");
        }).catch(err=>{
            alert("Failed to create session: "+(err?.message || "unknown error"));
        });
    }
    return(
        <>

                        <Formik
                            initialValues={{deadline: props.caseData.deadline.split('T')[0], description: props.caseData.description, atlas: props.caseData.atlas, allowDownload:props.caseData.allowDownload, allowView:props.caseData.allowView, allowCompare: props.caseData.allowCompare, allowDelete: props.caseData.allowDelete}}
                            validate={values => {
                                const errors = {};
                                return errors;
                            }}
                            onSubmit={({...v}, { setSubmitting }) => {
                                v.deadline=  new Date(v.deadline).toISOString();
                                tableDataModules.editCase(v,props.caseID).then(res => {
                                    setSubmitting(false);
                                })

                            }}
                        >
                            {({
                                  values,
                                  errors,
                                  touched,
                                  handleChange,
                                  handleBlur,
                                  handleSubmit,
                                  isSubmitting,
                                  /* and other goodies */
                              }) => (
                                <form onSubmit={handleSubmit}>
                                    <h4 style={{float: "left"}}>Edit case </h4>

                                        <Button style={{float: "right"}} type="submit" disabled={isSubmitting} variant="primary" >
                                            Save
                                        </Button>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-reprocess">
                                                Required when rules are updated or if the distance map is adjusted so that the submissions get new scores.
                                            </Tooltip>
                                        }
                                    >
                                        <Button
                                            style={{float: "right", marginRight: 5}}
                                            variant="warning"
                                            onClick={reprocess}
                                        >
                                            Reprocess student submissions
                                        </Button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-regenerate">
                                                Used when a case requires the ability to analyze larger distances from the golden standard.
                                            </Tooltip>
                                        }
                                    >
                                        <Button
                                            style={{float: "right", marginRight: 5}}
                                            variant="warning"
                                            onClick={regenerate}
                                        >
                                            Regenerate distancemap
                                        </Button>
                                    </OverlayTrigger>
                                <Button style={{float: "right", marginRight: 5}}  variant="danger" onClick={deleteCase}>
                                Delete
                                </Button>
                                <Button style={{float: "right", marginRight: 5}}  variant="success" onClick={newSession}>
                                New Session
                                </Button><br/>
                                    <Row className="mt-5">
                                        <Col lg={6}>
                                            <h5>
                                                General Information
                                            </h5>
                                            <hr/>
                                            <InputGroup className="mb-3">
                                                <span className="input-group-text">Deadline:</span>
                                                <Form.Control
                                                    type="date"
                                                    aria-label="Deadline date"
                                                    name="deadline"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.deadline}
                                                />
                                            </InputGroup>
                                            <h5>
                                                Student Permissions
                                            </h5>
                                            <hr/>
                                            <Col lg={6}>
                                                <Form.Check
                                                    type="switch"
                                                    label="Allow download and upload"
                                                    name="allowDownload"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    checked={values.allowDownload}
                                                />
                                                <Form.Check
                                                    type="switch"
                                                    label="Allow view"
                                                    name="allowView"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    checked={values.allowView}
                                                />
                                                <Form.Check
                                                    type="switch"
                                                    label="Allow compare to gold standard"
                                                    name="allowCompare"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    checked={values.allowCompare}
                                                />
                                                <Form.Check
                                                    type="switch"
                                                    label="Allow delete own work"
                                                    name="allowDelete"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    checked={values.allowDelete}
                                                />
                                            </Col>
                                        </Col>
                                        <Col lg={6}>
                                            <h5>
                                                Description
                                            </h5>
                                            <hr/>
                                            <p>
                                                Relevant information about the case. It will help observers get to know the case better so that they can create efficient delineations
                                            </p>
                                            <Form.Group className="mb-3">
                                                <Form.Control as="textarea" rows={5}
                                                              name="description"
                                                              onChange={handleChange}
                                                              onBlur={handleBlur}
                                                              value={values.description}/>
                                            </Form.Group>
                                            <h5>
                                                Provide Atlas link
                                            </h5>
                                            <hr/>

                                            <span style={{color: "red"}}>{errors.atlas && touched.atlas && errors.atlas}</span>
                                            <InputGroup className="mb-3">
                                                <span className="input-group-text">Atlas link:</span>
                                                <Form.Control
                                                    aria-label="atlas"
                                                    placeholder=""
                                                    name="atlas"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.atlas}
                                                />
                                            </InputGroup>

                                        </Col>
                                    </Row>

                                </form>
                            )}
                        </Formik>
        </>
    )
}

export default EditForm;